import React, { useEffect, useState } from 'react'
import {useLocation, useParams } from 'react-router-dom'
import api from '../utils/intercepter/axiosConfig';
import { useNavigate } from 'react-router-dom';
import QuittanceTrConservation from './quittance/QuittanceTrConservation';
import QuittanceTrEnregistrement from './quittance/QuittanceTrEnregistrement';

function ShowVente() {

  const navigate = useNavigate();

    const { id_vente } = useParams();
    const [w_id, setWId] = useState('');

    const  [statusActeVente, setStatusActeVente] = useState(false);

    //
    const {state} = useLocation();

    //Tr Conservation
    const [montantTrConservation, setMontantTrConservation] = useState(0);
    const [num_tr_code_conservation, setNumTrCodeConservation] = useState(0);
    const [etat_tr_conservation, setEtatTrConservation] = useState(0);
    const [id_tr_quittance_tr_conservation, setIdTrConservation] = useState(0);

    //Tr Enregistrement
    const [montantTrEnregistrement, setMontantTrEnregistrement] = useState(0);
    const [num_tr_code_enregistrement, setNumTrCodeEnregistrement] = useState(0);
    const [etat_tr_enregistrement, setEtatTrEnregistrement] = useState(0);
    const [id_tr_quittance_tr_enregistrement, setIdTrEnregistrement] = useState(0);

    const [vente, setVente] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    //
    const [type_acte, setTypeActe] = useState('');


    const [date_acte_vente, setDateActeVente] = useState('');
    const [num_acte_vente, setNumActeVente] = useState('');


    // v2 non notarie

    const [type_acte_non_notarie, setTypeActeNonNotarie] = useState('');
    const [date_acte_vente_non_notarie, setDateActeVenteNonNotarie] = useState('');
    const [num_acte_vente_non_notarie, setNumActeVenteNonNotarie] = useState('');
    const [num_acte_depot_non_notarie, setNumActeDepotNonNotarie] = useState('');
    const [date_acte_depot_non_notarie, setDateActeDepotNonNotarie] = useState('');
    const [vendu_par, setVenduPar] = useState('');

     const fetchVenteById = async () => {
                setLoading(true);
                try {

                    const response = await api.post("/auth/getVenteById", {
                        id_vente: id_vente
                    });

                    if (response.data.status) {
                        setVente(response.data.response);
                        setWId(response.data.response.w_id);
                        setTypeActe(Number(response.data.response.type_acte));
                    } else {
                        setError("Aucune vente trouvée.");
                    }

                } catch (error) {
                    setError("Erreur lors de la récupération des données.");
                } finally {
                    setLoading(false);
                }
            };

      const fetchTrConservationByWId = async () => {
        try {
          const response = await api.post('/auth/getTrConservationOfMutation',{
            w_id: w_id
          });

          if(response.data.status){
            setMontantTrConservation(response.data.response.montant);
            setNumTrCodeConservation(response.data.response.num_tr)
            setEtatTrConservation(response.data.response.etat);
            setIdTrConservation(response.data.response.id)
          }
          else{
            console.log("Aucun TF Conservation")
          }
        } catch (error) {
          console.log("Erreur Connexion")
        }
      }


      const fetchTrEnregistrementByWId = async () => {
        try {
          const response = await api.post('/auth/getTrEnregistrOfMutation',{
            w_id: w_id
          });

          if(response.data.status){
            setMontantTrEnregistrement(response.data.response.montant);
            setNumTrCodeEnregistrement(response.data.response.num_tr)
            setEtatTrEnregistrement(response.data.response.etat)
            setIdTrEnregistrement(response.data.response.id)
          }
          else{
            console.log("Aucun TF Enregistrement")
          }
        } catch (error) {
          console.log("Erreur Connexion")
        }
      }


    const checkStatusActeVente = async () => {
      try {
          const response = await api.post('/auth/checkStatusActeVente',{
             "vente_id":id_vente
          });

          if(response.data.status){
            setStatusActeVente(true)
          }
          else{
            setStatusActeVente(false)
          }
        } catch (error) {
          console.log("Erreur Connexion")
        }
    }

const getInforActeVenteNotarie = async () => {
  try {
    const response = await api.post("/auth/getInforActeVenteNotarie",{
      "id_vente": id_vente
    });

    if(response.data.status) {
      console.log(response.data.response);
      setDateActeVente(response.data.response.date_acte_vente);
      setNumActeVente(response.data.response.num_acte_vente);
    } else {
      console.log("API a renvoyé status false pour getInforActeVenteNotarie");
    }
  } catch (error) {
    console.error("Erreur API getInforActeVenteNotarie:", error);
  }
}

const getInfoActeVenteNonNotarie = async () => {
  try {
    const response = await api.post("/auth/getInfoActeVenteNonNotarie",{
      "id_vente": id_vente
    });

    if(response.data.status) {
      setTypeActeNonNotarie(response.data.response.type_acte)
      setDateActeVenteNonNotarie(response.data.response.date_acte_vente)
      setNumActeVenteNonNotarie(response.data.response.num_acte_vente)
      setNumActeDepotNonNotarie(response.data.response.num_acte_depot)
      setDateActeDepotNonNotarie(response.data.response.date_acte_depot)
      setVenduPar(response.data.response.vendu_par)
    } else {
      console.log("API a renvoyé status false pour getInforActeVenteNotarie");
    }
  } catch (error) {
    console.error("Erreur API getInforActeVenteNotarie:", error);
  }
}



useEffect(() => {

  if(!type_acte) return;
  const fetchData = async () => {
    try {
      if(Number(type_acte) === 1 || Number(type_acte) === 2){
        await getInforActeVenteNotarie();
      }
      else{
        await getInfoActeVenteNonNotarie();
      }
    } catch (e) {

    }
  }

  fetchData();

}, [type_acte, id_vente]);

        useEffect(() => {
        if (id_vente) {
           fetchVenteById();
           checkStatusActeVente();
        }
    }, [id_vente]);

    useEffect(() => {
      if(w_id){
        fetchTrConservationByWId();
        fetchTrEnregistrementByWId();
      }
    }, [w_id])



    if (loading) {
        return (
            <div className="text-center">
                <p>Chargement des données...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="alert alert-danger">
                {error}
            </div>
        );
    }

    if (!vente) {
        return (
            <div className="alert alert-warning">
                Aucune donnée disponible.
            </div>
        );
    }

    const retour = () => {
        navigate(-1);
    }

    return (
        <div className='main-container'>
            <div className='container'>

              <div className="row">
                  <div className='col-12 col-md-4 mb-4'>
                <div className="card mt-4">

                  <div className="card-header d-flex justify-content-between align-items-center">
                    <span>Les informations de la vente</span>
                    <button onClick={retour} className='btn btn-secondary btn-sm'>
                      Retour
                    </button>
                  </div>

                    <div className="card-body">

                         <table className="table table-bordered table-striped">
              <tbody>
                <tr>
                  <td className="text-start">N° demande</td>
                  <td className="text-end">{vente.num_demande}</td>
                </tr>
                
                <tr>
                  <td className="text-start">NNI Vendeur</td>
                  <td className="text-end">{vente.nni_vendeur}</td>
                </tr>
                <tr>
                  <td className="text-start">Nom Vendeur</td>
                  <td className="text-end">{vente.nom_vendeur}</td>
                </tr>
                <tr>
                  <td className="text-start">NNI Acheteur</td>
                  <td className="text-end">{vente.nni_acheteur}</td>
                </tr>
                <tr>
                  <td className="text-start">Nom Acheteur</td>
                  <td className="text-end">{vente.nom_acheteur}</td>
                </tr>
                <tr>
                  <td className="text-start">TF</td>
                  <td className="text-end">
                    <span className="badge bg-warning text-white">
                      {vente.tf}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="text-start">Montant</td>
                  <td className="text-end">
                    <span className="fw-bold text-success">

                      {vente.montant.toLocaleString('fr-FR', {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      })} MRU

                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="text-start">Date</td>
                  <td className="text-end">{vente.date}</td>
                </tr>
                <tr>
                  <td className="text-start">État</td>
                  <td className="text-end">
                    {vente.Etat === 1 ? (
                      <span className="badge bg-success">En cours de vente</span>
                    ) : (
                      <span className="badge bg-danger">Non Validée</span>
                    )}
                  </td>
                </tr>
                

                {((type_acte === 1) || (type_acte === 2)) ? (
                  <>
                    <tr>
                      <td className="text-start">Type Acte</td>
                      <td className="text-end">Notarie</td>
                    </tr>
                    {num_acte_vente && (
                      <tr>
                        <td className="text-start">Numéro Acte de Vente</td>
                        <td className="text-end">{num_acte_vente}</td>
                      </tr>
                    )}
                    {date_acte_vente && (
                      <tr>
                        <td className="text-start">Date de l'Acte de Vente</td>
                        <td className="text-end">{date_acte_vente}</td>
                      </tr>
                    )}
                  </>
                ) : (
                  <>
                    {type_acte_non_notarie && (
                      <tr>
                        <td className="text-start">Type acte</td>
                        <td className="text-end">{type_acte_non_notarie}</td>
                      </tr>
                    )}
                    {date_acte_vente_non_notarie && (
                      <tr>
                        <td className="text-start">Date acte de vente</td>
                        <td className="text-end">{date_acte_vente_non_notarie}</td>
                      </tr>
                    )}
                    {num_acte_vente_non_notarie && (
                      <tr>
                        <td className="text-start">Numéro acte de vente</td>
                        <td className="text-end">{num_acte_vente_non_notarie}</td>
                      </tr>
                    )}
                    {num_acte_depot_non_notarie && (
                      <tr>
                        <td className="text-start">Numéro acte depot</td>
                        <td className="text-end">{num_acte_depot_non_notarie}</td>
                      </tr>
                    )}
                    {date_acte_depot_non_notarie && (
                      <tr>
                        <td className="text-start">Date acte depot</td>
                        <td className="text-end">{date_acte_depot_non_notarie}</td>
                      </tr>
                    )}
                    {vendu_par && (
                      <tr>
                        <td className="text-start">Vendu par</td>
                        <td className="text-end">{vendu_par}</td>
                      </tr>
                    )}
                  </>
                )}


              </tbody>
            </table>

                  <span className='text-start'>TR Conservation</span>
                   <table className='table table-bordered table-striped'>
                        <tbody>
                          <tr>
                            <td className='text-start'>Montant</td>
                            <td> 
                              {montantTrConservation.toLocaleString('fr-FR', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                              })} MRU
                            </td>
                          </tr>
                          <tr>
                            <td className='text-start'>Code</td>
                            <td>
                              {num_tr_code_conservation.toLocaleString()}
                            </td>
                          </tr>
                          <tr>
                            <td className='text-start'>
                              Opérations
                            </td>
                            <td  className="d-flex align-items-center gap-2">
                                                       
                                                       <button className="btn btn-warning btn-sm d-flex align-items-center"
                                                       >
                                                       
                                                            Recevoir
                                                           </button>
                                                           {etat_tr_conservation === 0 ? (
                                                            <button 
                                                            className='btn btn-success btn-sm d-flex align-items-center'
                                                            onClick={() => navigate(`/vente/paiements/${vente.w_id}`,{
                                                             state: {
                                                              id_vente: id_vente
                                                             } 
                                                            })}>
                                                              
                                                                    Payé
                                                            </button>
                                                           ) :(''
                                                            // <button
                                                            // className='btn btn-success btn-sm d-flex align-items-center'
                                                            // // onClick={() => {
                                                            // //   navigate(`/vente/quittance/tr/conservation/${id_tr_quittance_tr_conservation}/${w_id}`)
                                                            // // }}
                                                            // >
                                                            //   Quittance
                                                            // </button>
                                                           )}
                                                        </td> 
                          </tr>

                        </tbody>
                      </table>
                      

                      {etat_tr_conservation === 1 ? (
                        <QuittanceTrConservation 
                        id_quittance_tr_conservation={id_tr_quittance_tr_conservation}
                        w_id={w_id}
                        />
                      ) : ('')}


                      <span className='text-start'>TR Enregistrement</span>
                   <table className='table table-bordered table-striped'>
                        <tbody>
                          <tr>
                            <td className='text-start'>Montant</td>
                            <td>
                              
                              {montantTrEnregistrement.toLocaleString('fr-FR', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                              })} MRU

                            </td>
                          </tr>
                          <tr>
                            <td className='text-start'>Code</td>
                            <td>
                              {num_tr_code_enregistrement.toLocaleString()}
                            </td>
                          </tr>
                          <tr>
                            <td className='text-start'>
                              Opérations
                            </td>
                            <td  className="d-flex align-items-center gap-2">
                                                       
                                                       <button className="btn btn-warning btn-sm d-flex align-items-center"
                                                       >
                                                        
                                                            Envoyer
                                                           </button>

                                                           {etat_tr_enregistrement === 0 ? (
                                                            <button 
                                                            className='btn btn-success btn-sm d-flex align-items-center'
                                                            onClick={() => navigate(`/vente/paiements/tr/enregistrement/${vente.w_id}`,{
                                                             state: {
                                                              id_vente: id_vente
                                                             } 
                                                            })}>
                                                              
                                                                    Payé
                                                            </button>
                                                           ) :(''
                                                            // <button

                                                            // className='btn btn-success btn-sm d-flex align-items-center'
                                                            // onClick={() => {
                                                            //   navigate(`/vente/quittance/tr/enregistrement/${id_tr_quittance_tr_enregistrement}/${w_id}`)
                                                            // }}
                                                            // >
                                                            //   Quittance
                                                            // </button>
                                                           )}
                                                        </td> 
                          </tr>

                        </tbody>
                      </table>
                    {etat_tr_enregistrement === 1 ? (
                                      <QuittanceTrEnregistrement
                                            id_quittance_tr_enregistrement={id_tr_quittance_tr_enregistrement}
                                            w_id={w_id}
                                            />
                                          ) : ('')}

                                {/* Acte de vente  */}

                                  {etat_tr_conservation === 1 && etat_tr_enregistrement === 1 && statusActeVente === false ? (
                                    <div className='row'>
                                      <div className='col-12'>
                                        <button
                                          className='btn btn-secondary btn-sm w-100'
                                          onClick={() => {
                                            navigate(`/vente/acte-vente/${id_vente}`);
                                          }}
                                        >
                                          Initier l'Acte de Vente
                                        </button>
                                      </div>
                                    </div>
                                  ) : null}

                               
                    </div>
                </div>
                </div>
              </div>
            
            </div>
        </div>
    );
}

export default ShowVente;
